// --------------------- Import Globais ---------------------
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// --------------------- Import Antd-Design ---------------------
import {
  Modal,
  Form,
  Input,
  Radio,
  RadioChangeEvent,
  DatePicker,
  Select,
  Skeleton,
} from "antd";

// --------------------- Import Styles ---------------------
import { formStyle, layout, Title } from "../styles";

// --------------------- Import Hooks ---------------------
import { useAtualizarPostagem } from "../hooks/useAtualizarPostagem";
import { useBuscarPostagensById } from "../hooks/useBuscarPostagensById";
// --------------------- Import Uteis ---------------------
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";

// --------------------- Import dayJS ---------------------
import dayjs from "dayjs";
import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useBuscarLeadsById } from "../../viewGerenciarPessoas/hooks/useBuscarLeadsById";
import { useBuscarEmpreendimentoById } from "../hooks/useBuscarEmpreendimentoById";
import { useBuscarFonteById } from "../hooks/useBuscarFonteById";
import { useBuscarGrupoById } from "../hooks/useBuscarGrupoById";
import { useBuscarEmpreendimentos } from "../../ViewGerenciarPropriedadeUsuario/hooks/useBuscarEmpreendimentos";
import { useBuscarFonte } from "../hooks/useBuscarFonte";
import { useMessage } from "../../../uteis/mensagens/useMessage";

export default function ModalEditar({
  isModalOpen,
  handleFechar,
  postagemId,
}: any) {
  const [formPostagem] = Form.useForm();

  // Chamada da função de atualização
  const {
    atualizar,
    isLoading: isLoadingAtualizar,
    error,
    success,
    warning,
    resetWarning,
  } = useAtualizarPostagem();

  const { postagem, isLoading } = useBuscarPostagensById(
    postagemId,
    isModalOpen
  );

  const {
    isLoading: isLoadingEmpreendimento,
    empreendimento: empreendimentos,
  } = useBuscarEmpreendimentos(isModalOpen);

  const { leads } = useBuscarLeadsById(postagem?.idLeads, isModalOpen);
  const { empreendimento } = useBuscarEmpreendimentoById(
    postagem?.idEmpreendimento,
    isModalOpen
  );
  const { fonte } = useBuscarFonteById(postagem?.idFonte, isModalOpen);
  const { grupo } = useBuscarGrupoById(postagem?.idGrupo, isModalOpen);

  const { fontes } = useBuscarFonte(isModalOpen);

  dayjs.extend(customParseFormat);

  // UseStates necessários para armazenar os dados que irão ser atualizados
  const [ativar, setAtivar] = useState<number>();
  const [alugar, setAlugar] = useState<number>();
  const [trocar, setTrocar] = useState<number>();
  const [compra, setCompra] = useState<number>();
  const [venda, setVenda] = useState<number>();
  const [tipoInteresse, setTipoInteresse] = useState<string>();

  // Função que armazena o dado selecionado do alugar
  const ativarChange = (e: RadioChangeEvent) => {
    setAtivar(e.target.value);
  };

  // Função que armazena o dado selecionado do alugar
  const alugarChange = (e: RadioChangeEvent) => {
    setAlugar(e.target.value);
  };

  // Função que armazena o dado selecionado da troca
  const trocarChange = (e: RadioChangeEvent) => {
    setTrocar(e.target.value);
  };

  // Função que armazena o dado selecionado da compra
  const compraChange = (e: RadioChangeEvent) => {
    setCompra(e.target.value);
  };

  // Função que armazena o dado selecionado da venda
  const vendaChange = (e: RadioChangeEvent) => {
    setVenda(e.target.value);
  };
  // Função que armazena o dado selecionado do alugar
  const tipoInteresseChange = (e: RadioChangeEvent) => {
    setTipoInteresse(e.target.value);
  };
  const errorRef = useRef<boolean | null>(false);

  // Atualiza o valor de errorRef e warningRef toda vez que o error e warning mudar
  useEffect(() => {
    if (error) {
      errorRef.current = error;
    }
  }, [error]);

  // Estado inicial de dos dados Postagem que serão atualizados
  const [postagemData, setPostagemData] = useState<any>({});

  // Função que armazena os dados alterados de Apartamento
  const postagemChange = (changedValues: Partial<any>, allValues: any) => {
    setPostagemData(allValues);
  };

  // Exibe a Mensagem
  const { showSuccess, showError, showWarning, contextHolder } = useMessage();

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);
  const [warningDisplayed, setWarningDisplayed] = useState(false);
  // Hook de navegação do React Router
  const navigate = useNavigate();

  useEffect(() => {
    if (isModalOpen) {
      // Exibe a mensagem de sucesso
      if (success && !successDisplayed) {
        const msgSuccess = "Postagem atualizada com sucesso!";
        showSuccess(msgSuccess);
        setSuccessDisplayed(true);

        // Limpa estado de sucesso após 3 segundos e recarrega a página
        setTimeout(() => {
          setSuccessDisplayed(false);
          navigate(0);
        }, 3000);
      }

      // Exibe a mensagem de erro
      if (errorRef.current && !errorDisplayed) {
        const msgError =
          "Não foi possível atualizar a postagem! Tente Novamente!";
        showError(msgError);
        setErrorDisplayed(true);

        // Limpa estado de error após 3 segundos
        setTimeout(() => {
          setErrorDisplayed(false);
          errorRef.current = null;
        }, 3000);
      }

      if (warning && !warningDisplayed) {
        showWarning(warning);
        setWarningDisplayed(true);

        // Limpa estado de error após 3 segundos
        setTimeout(() => {
          setWarningDisplayed(false);
          resetWarning();
        }, 3000);
      }
    } else {
      // Reseta os estados ao fechar o modal
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    showSuccess,
    showError,
    showWarning,
    warning,
    warningDisplayed,
    errorDisplayed,
    successDisplayed,
    navigate,
  ]);

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
  };
  /* eslint-enable no-template-curly-in-string */

  useEffect(() => {
    if (!formPostagem) {
      return;
    }
    formPostagem.setFieldsValue({
      idLeads: leads?.nome,
      idEmpreendimento: empreendimento?.id,
      idFonte: fonte?.nome,
      idGrupo: grupo?.nome,
      active: postagem?.active,
      dataDivulgacao: postagem?.dataDivulgacao
        ? dayjs(postagem?.dataDivulgacao)
        : null,
      tipoInteresse: postagem?.tipoInteresse,
      troca: postagem?.troca,
      aluguel: postagem?.aluguel,
      compra: postagem?.compra,
      venda: postagem?.venda,
      dataIni: postagem?.dataIni ? dayjs(postagem?.dataIni) : null,
      dataFim: postagem?.dataFim ? dayjs(postagem?.dataFim) : null,
    });
  }, [formPostagem, postagem, leads, empreendimento, fonte, grupo]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Atualizar"
        onOk={() =>
          atualizar(
            postagemId,
            postagemData,
            postagem?.idLeads,
            postagem?.idEmpreendimento,
            postagem?.idFonte,
            postagem?.idGrupo
          )
        }
        confirmLoading={isLoadingAtualizar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {isLoadingEmpreendimento && <Skeleton />}
        {!isLoading && !isLoadingEmpreendimento && (
          <>
            <>{contextHolder}</>

            <Form
              {...layout}
              form={formPostagem}
              onValuesChange={(changedValues, allValues) =>
                postagemChange(changedValues, allValues)
              }
              name="postagem"
              style={formStyle}
              validateMessages={validarFormulario}
            >
              <Title>Editar</Title>

              <Form.Item name={["idLeads"]} label="Lead " className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name={["idEmpreendimento"]}
                label="Empreendimento "
                className="formItems"
              >
                <Select placeholder="Empreendimento">
                  {empreendimentos.map((emp, index) => (
                    <Select.Option key={emp.id} value={emp.id}>
                      {emp.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["idFonte"]}
                label="Fonte "
                className="formItems"
              >
                <Select placeholder="Fonte">
                  {fontes.map((fonte: any, index: any) => (
                    <Select.Option key={fonte.id} value={fonte.nome}>
                      {fonte.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["idGrupo"]}
                label="Grupo "
                className="formItems"
              >
                <Input />
              </Form.Item>
              <Form.Item name={["active"]} label="Ativo " className="formItems">
                <Radio.Group onChange={ativarChange} value={ativar}>
                  <Radio value={0}>Desativado</Radio>
                  <Radio value={1}>Ativado</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["dataDivulgacao"]}
                label="Data Divulgação "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["tipoInteresse"]}
                label="Tipo Interesse "
                className="formItems"
              >
                <Radio.Group
                  onChange={tipoInteresseChange}
                  value={tipoInteresse}
                >
                  <Radio value={"DISPONIBILIZA"}>Disponibiliza</Radio>
                  <Radio value={"PROCURA"}>Procura</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["aluguel"]}
                label="Alugar "
                className="formItems"
              >
                <Radio.Group onChange={alugarChange} value={alugar}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item name={["troca"]} label="Trocar " className="formItems">
                <Radio.Group onChange={trocarChange} value={trocar}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["compra"]}
                label="Compra "
                className="formItems"
              >
                <Radio.Group onChange={compraChange} value={compra}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item name={["venda"]} label="Venda " className="formItems">
                <Radio.Group onChange={vendaChange} value={venda}>
                  <Radio value={0}>Não</Radio>
                  <Radio value={1}>Sim</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name={["dataIni"]}
                label="Data Inicio "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
              <Form.Item
                name={["dataFim"]}
                label="Data Fim "
                className="formItems"
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            </Form>
          </>
        )}
      </Modal>
    </>
  );
}
